import { Component } from 'react';
import getComponentName from 'react-utils/getComponentName';
import invariant from 'react-utils/invariant';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withPartials() {
  return WrappedComponent => {
    class WithPartials extends Component {
      constructor(props) {
        super(props);
        this.partial = this.partial.bind(this);
        this.partials = new Map();
      }
      componentWillUnmount() {
        this.partials = null;
      }
      partial(func, ...args) {
        invariant(typeof func === 'function', '%s.partial: expected `func` to be a function but got `%s`.', getComponentName(WrappedComponent), func);
        if (!this.partials) {
          return null;
        }
        const keyList = [func, ...args];
        if (!this.partials.has(keyList)) {
          this.partials.set(keyList, (...partialArgs) => func(...args, ...partialArgs));
        }
        return this.partials.get(keyList);
      }
      render() {
        return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
          partial: this.partial
        }));
      }
    }
    WithPartials.wrappedComponent = WrappedComponent;
    return WithPartials;
  };
}